// extracted by css-extract-rspack-plugin
export default {"cls1":"AnalyticsV2NavBar-cls1_dM2","cls2":"AnalyticsV2NavBar-cls2_g0q AnalyticsV2NavBar-cls1_dM2"};